export default {
  TableHead: [
    [
      {
        displayName: 'statement.datatable.number',
      },
      {
        displayName: 'statement.datatable.loginname',
      },
      {
        displayName: 'statement.datatable.currency',
      },
      {
        displayName: 'statement.datatable.action',
      },
      {
        displayName: 'statement.datatable.amount',
      },
      {
        displayName: 'statement.datatable.requestby',
      },
      {
        displayName: 'statement.datatable.date',
      },
    ],
  ],
};
